// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2ql-L","title":"AfterBackImages_title__2VZu7","images":"AfterBackImages_images__1QVuO"};